import { ArrowDown, ArrowUp } from 'lucide-react';

export interface MobileSortOption<T extends string> {
  value: T;
  label: string;
}

export interface MobileSortControlProps<T extends string> {
  label: string;
  options: Array<MobileSortOption<T>>;
  sortBy: T;
  sortDirection: 'asc' | 'desc';
  onSortChange: (sortBy: T) => void;
}

export function MobileSortControl<T extends string>({
  label,
  options,
  sortBy,
  sortDirection,
  onSortChange,
}: MobileSortControlProps<T>) {
  const Icon = sortDirection === 'asc' ? ArrowUp : ArrowDown;

  return (
    <div className="flex items-end gap-2 border-b border-neutral-200 bg-white px-4 py-3">
      <label className="flex min-w-0 flex-1 flex-col gap-1 text-small font-medium text-neutral-700">
        {label}
        <select
          value={sortBy}
          onChange={(event) => onSortChange(event.target.value as T)}
          className="h-10 min-w-0 rounded-lg border border-neutral-200 bg-white px-3 text-body text-neutral-900"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      <button
        type="button"
        className="focus-ring inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-neutral-200 bg-white text-neutral-600 hover:bg-backoffice-50"
        aria-label={`Toggle sort direction, currently ${sortDirection === 'asc' ? 'ascending' : 'descending'}`}
        onClick={() => onSortChange(sortBy)}
      >
        <Icon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
